import { formatDate } from '@angular/common';
import moment from 'moment';

export const DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const MONTH_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const APP_DATE_FORMAT = 'MM/dd/yyyy';

export function formatDateDto(date: Date | null): string {
  return date ? formatDate(date, 'yyyy-MM-dd', 'en-US') : null;
}

export function getDefaultPositionChangeEventDate(reference: Date = new Date()): Date {
  const year = reference.getFullYear();
  const startOfYear = new Date(year, 0, 1);
  const midOfYear = new Date(year, 6, 1);
  if (reference.getMonth() < 6) {
    return startOfYear;
  }
  return midOfYear;
}

/**
 * Reinterprets the date's local clock time as UTC (no instant shift) and serializes
 * it in ISO-8601, e.g. `2026-05-01T00:00:00Z`. Returns `''` for nullish input.
 */
export function dateToStringWithoutTimezone(date: Date | moment.Moment): string {
  return date ? moment(date).utcOffset(0, true).format() : '';
}

export function daysBetweenInclusive(start: string | Date, end: string | Date): number {
  return moment(end).diff(moment(start), 'days') + 1;
}
